module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_fails.js
// module id = 131
// module chunks = 0